// utils/smoothScroll.js

// Anchor hrefs are not guaranteed to be valid selectors — a bare href="#", or
// rich text that emits something like #token=abc, makes querySelector throw a
// SyntaxError out of the document-level click handler. Degrade to a no-op.
const resolveTarget = (target) => {
  if (typeof target !== 'string') return target;

  try {
    return document.querySelector(target);
  } catch (e) {
    return null;
  }
};

export const smoothScrollTo = (target, offset = 0) => {
  const element = resolveTarget(target);

  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    
    // Get the computed scroll margin top of the target element
    const computedStyle = window.getComputedStyle(element);
    const scrollMarginTop = parseFloat(computedStyle.scrollMarginTop) || 0;
    
    // Calculate final position accounting for scroll margin and additional offset
    const offsetPosition = elementPosition + window.pageYOffset - scrollMarginTop - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

// Handle anchor links. Returns a teardown function to remove the listener (e.g. for useEffect cleanup).
export const setupSmoothScrolling = () => {
  const handleClick = (e) => {
    const target = e.target.closest('a[href^="#"]');
    if (target) {
      e.preventDefault();
      const targetId = target.getAttribute('href');
      smoothScrollTo(targetId);
    }
  };
  document.addEventListener('click', handleClick);
  return () => document.removeEventListener('click', handleClick);
};